<template>
    <div class="inspiration-progressbar3-container">
        <div class="border">
            <div class="inspiration-progressbar3-container-top">
                <div class="inspiration-progressbar3-container-top-title">{{ $t(props.progressItem.title) }}</div>
                <div class="inspiration-progressbar3-container-top-text">
                    <span v-html="$t(props.progressItem.text)" />
                    <span class="blue">&nbsp;{{ $t(props.progressItem.hour) }}</span>
                </div>
            </div>
            <div class="inspiration-progressbar3-container-bottom">
                <div class="inspiration-progressbar3-container-bottom-text">{{ $t(info.faster) }}</div>

                <div class="inspiration-progressbar3-container-bottom-compare">
                    <div class="inspiration-progressbar3-container-bottom-compare-number">
                        {{ isfloat(props.progressItem.tiemsnum) ? data.num.toFixed(1) : data.num.toFixed(0) }}
                    </div>
                    <div class="inspiration-progressbar3-container-bottom-compare-text">&nbsp;{{ $t(info.times) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { gsap } from 'gsap';
    import { reactive } from 'vue';
    import { ScrollTrigger } from 'gsap/all';
    gsap.registerPlugin(ScrollTrigger);
    const props = defineProps<{
        progressItem: FunctionTitle;
        progressIndex: number;
    }>();

    const info = reactive({
        tradition: 'global_solutions_manufacturer_arrows_progressbar_tradition',
        day: 'global_solutions_manufacturer_arrows_progressbar_day',
        dimensional: 'global_solutions_manufacturer_arrows_progressbar_3d',
        hour: 'global_solutions_manufacturer_arrows_progressbar_hour',
        faster: 'global_solutions_manufacturer_arrows_progressbar_faster',
        times: 'global_solutions_manufacturer_arrows_progressbar_times',
    });
    const data = reactive({
        num: 0,
    });

    const isfloat = (num) => {
        if (String(num).includes('.')) {
            return true;
        } else {
            return false;
        }
    };

    onMounted(() => {
        ScrollTrigger.create({
            // markers: { startColor: 'green', endColor: 'red', fontSize: '12px' },
            trigger: '.inspiration-progressbar3-container',
            start: 'top-=712 top',
            end: 'bottom bottom',
            onEnter: () => {
                gsap.to(data, {
                    duration: 0.5,
                    num: props.progressItem.tiemsnum,
                });
            },
            onLeaveBack: () => {
                gsap.to(data, {
                    duration: 0.5,
                    num: 0,
                });
            },
        });
    });
</script>

<style lang="less" scoped>
    .inspiration-progressbar3-container {
        height: .convert(397px) [ @vw];
        width: .convert(400px) [ @vw];
        padding: .convert(60px) [ @vw] 0px;
        font-family: HarmonyOS Sans SC;
        font-style: normal;
        line-height: normal;
        color: #fff;
        font-weight: 400;
        @media (max-width: @screen-mobile-width) {
            width: 100%;
            height: auto;
        }

        &-top {
            &-title {
                color: var(--grey-1, #fff);
                font-size: .convert(36px) [ @vw];
                margin-bottom: .convert(12px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    font-size: 20px;
                    margin-bottom: .convert(15px) [ @vh];
                }
            }
            &-text {
                font-size: .convert(20px) [ @vw];
                .blue {
                    color: #32ffff;
                }
                @media (max-width: @screen-mobile-width) {
                    font-size: 12px;
                }
            }
        }

        &-bottom {
            margin-top: .convert(55px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                display: flex;
                flex-flow: row;
                align-items: flex-end;
                margin-left: 19px;

                margin-top: .convert(0px) [ @vw];
            }
            &-text {
                font-size: .convert(16px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    font-size: 12px;
                }
            }
            &-compare {
                display: flex;
                flex-flow: row;
                align-items: flex-end;
                line-height: .convert(96px) [ @vw];

                &-number {
                    font-size: .convert(96px) [ @vw];
                    background: linear-gradient(90deg, #32ffff 0%, #3cff64 100%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    @media (max-width: @screen-mobile-width) {
                        font-size: .convert(32px) [ @vh];
                    }
                }
                &-text {
                    background: linear-gradient(90deg, #32ffff 0%, #3cff64 100%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    font-size: .convert(32px) [ @vw];
                    line-height: .convert(56px) [ @vw];
                }
            }
        }
        .border {
            padding-left: .convert(60px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                display: flex;
                flex-flow: row;
            }
        }
    }

    :lang(en) {
        .inspiration-progressbar3-container {
            .inspiration-progressbar3-container-top-title {
                height: .convert(80px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    white-space: nowrap;
                    height: auto;
                    width: .convert(600px) [ @vw];
                }
            }
            .inspiration-progressbar3-container-top-text {
                width: .convert(300px) [ @vw];

                @media (max-width: @screen-mobile-width) {
                    width: .convert(600px) [ @vw];
                }
            }
        }
    }
</style>
